var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "o-productGrid" }, [
    _c("h3", [_vm._v(_vm._s(_vm.getKategoriaNazov) + " pre tvoju kravičku")]),
    _vm._v(" "),
    _vm.obchod[0]
      ? _c(
          "div",
          { staticClass: "m-productGrid__list", class: _vm.sizeByCategory },
          _vm._l(_vm.obchod.filter(_vm.checkCategory), function(item, index) {
            return _c("obchod-product-item", {
              key: index,
              attrs: { index: index, item: item },
              on: {
                buyProduct: function($event) {
                  _vm.$emit("buyProduct", _vm.obchod.indexOf(item), item)
                }
              }
            })
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }